var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm no-margin",
          attrs: { title: "밀폐작업 상세정보" },
        },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-chip",
                { attrs: { dense: "" } },
                [
                  _vm._v(" 작업인원수 "),
                  _c(
                    "q-avatar",
                    {
                      staticClass: "workpermit-worker-info asdasda",
                      attrs: { color: "blue", "text-color": "white" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.workPermit.workers &&
                              _vm.workPermit.workers.length > 0
                              ? _vm.workPermit.workers.length
                              : 0
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3" },
              [
                _c("c-text", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: !_vm.isWriting,
                    label: "공사명(작업명)",
                    name: "sopName",
                  },
                  model: {
                    value: _vm.workPermit.sopName,
                    callback: function ($$v) {
                      _vm.$set(_vm.workPermit, "sopName", $$v)
                    },
                    expression: "workPermit.sopName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3" },
              [
                _c("c-text", {
                  attrs: {
                    required: true,
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    label: "작업내용",
                    name: "workSummary",
                  },
                  model: {
                    value: _vm.workPermit.workSummary,
                    callback: function ($$v) {
                      _vm.$set(_vm.workPermit, "workSummary", $$v)
                    },
                    expression: "workPermit.workSummary",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-9 col-sm-9 col-md-9 col-lg-9" },
                    [
                      _c("c-text", {
                        attrs: {
                          required: true,
                          disabled: !_vm.isWriting,
                          editable: _vm.editable,
                          label: "단위공정/작업장소",
                          name: "workLocation",
                        },
                        model: {
                          value: _vm.workPermit.workLocation,
                          callback: function ($$v) {
                            _vm.$set(_vm.workPermit, "workLocation", $$v)
                          },
                          expression: "workPermit.workLocation",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-3" },
                    [
                      _c("c-select", {
                        attrs: {
                          disabled: !_vm.isWriting,
                          editable: _vm.editable,
                          comboItems: _vm.workLocationItems,
                          type: "none",
                          itemText: "codeName",
                          itemValue: "code",
                          name: "workLocationFlag",
                          label: "",
                        },
                        model: {
                          value: _vm.workPermit.workLocationFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.workPermit, "workLocationFlag", $$v)
                          },
                          expression: "workPermit.workLocationFlag",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-4 col-md-2 col-lg-2" },
              [
                _c("c-select", {
                  attrs: {
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    codeGroupCd: "SWP_WORK_CLASS_CD",
                    rejectItems: ["SWC0000005"],
                    type: "edit",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "swpWorkClassCd",
                    label: "작업구분",
                  },
                  model: {
                    value: _vm.workPermit.swpWorkClassCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.workPermit, "swpWorkClassCd", $$v)
                    },
                    expression: "workPermit.swpWorkClassCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-4 col-md-2 col-lg-2" },
              [
                _c("c-text", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    label: "신청업체",
                    name: "request",
                  },
                  model: {
                    value: _vm.request,
                    callback: function ($$v) {
                      _vm.request = $$v
                    },
                    expression: "request",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-4 col-md-2 col-lg-2" },
              [
                _c("c-radio", {
                  attrs: {
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    codeGroupCd: "HAZARD_PREVENTION_PLAN_CD",
                    label: "유해위험방지계획서",
                    name: "hazardPreventionPlanCd",
                  },
                  model: {
                    value: _vm.workPermit.hazardPreventionPlanCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.workPermit, "hazardPreventionPlanCd", $$v)
                    },
                    expression: "workPermit.hazardPreventionPlanCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-4 col-md-2 col-lg-2" },
              [
                _c("c-text", {
                  attrs: {
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    phoneNumberCheck: true,
                    label: "비상연락처",
                    name: "emergencyContact",
                  },
                  model: {
                    value: _vm.workPermit.emergencyContact,
                    callback: function ($$v) {
                      _vm.$set(_vm.workPermit, "emergencyContact", $$v)
                    },
                    expression: "workPermit.emergencyContact",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c("c-multi-field", {
                  attrs: {
                    required: true,
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    userInfoSearch: _vm.userInfoSearch,
                    userInfo: _vm.userInfo,
                    type: "dept_user",
                    userType: "lnf",
                    label: "L&F 담당자",
                    beforeText: "",
                    name: "workManagerId",
                  },
                  on: {
                    "update:userInfo": function ($event) {
                      _vm.userInfo = $event
                    },
                    "update:user-info": function ($event) {
                      _vm.userInfo = $event
                    },
                  },
                  model: {
                    value: _vm.workPermit.workManagerId,
                    callback: function ($$v) {
                      _vm.$set(_vm.workPermit, "workManagerId", $$v)
                    },
                    expression: "workPermit.workManagerId",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c("c-checkbox", {
                  attrs: {
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    codeGroupCd: "SOP_SAFETY_CERTIFICATION_CD",
                    isObject: true,
                    valueText: "sopSafetyCertificationName",
                    valueKey: "sopSafetyCertificationCd",
                    label: "안전인증 대상설비",
                    name: "safetyCertifications",
                  },
                  model: {
                    value: _vm.workPermit.safetyCertifications,
                    callback: function ($$v) {
                      _vm.$set(_vm.workPermit, "safetyCertifications", $$v)
                    },
                    expression: "workPermit.safetyCertifications",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c("c-checkbox", {
                  attrs: {
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    codeGroupCd: "SOP_AUTO_SAFETY_CONFIRM_CD",
                    isObject: true,
                    valueText: "sopAutoSafetyConfirmName",
                    valueKey: "sopAutoSafetyConfirmCd",
                    label: "자율안전확인신고 대상 설비",
                    name: "autoSafetyConfirms",
                  },
                  model: {
                    value: _vm.workPermit.autoSafetyConfirms,
                    callback: function ($$v) {
                      _vm.$set(_vm.workPermit, "autoSafetyConfirms", $$v)
                    },
                    expression: "workPermit.autoSafetyConfirms",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c("c-textarea", {
                  attrs: {
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    rows: 2,
                    label: "기타요구사항(업체작성)",
                    name: "specialRequirements",
                  },
                  model: {
                    value: _vm.workPermit.specialRequirements,
                    callback: function ($$v) {
                      _vm.$set(_vm.workPermit, "specialRequirements", $$v)
                    },
                    expression: "workPermit.specialRequirements",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3" },
          [
            _c("c-table", {
              staticClass: "q-mt-md",
              attrs: {
                title: "안전조치 요구사항",
                columns: _vm.grid.columns,
                gridHeight: _vm.grid.height,
                data: _vm.workPermit.checkResults,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable && _vm.isWriting,
                contentsField: _vm.contentsField,
              },
              on: { "table-data-change": _vm.tableDataChange },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2" },
          [
            _c("c-table", {
              staticClass: "q-mt-md",
              attrs: {
                title: "보호구",
                columns: _vm.grid3.columns,
                gridHeight: _vm.grid3.height,
                data: _vm.workPermit.protectiveGears,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable && _vm.isWriting,
                contentsField: _vm.contentsField,
              },
              on: { "table-data-change": _vm.tableDataChange },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7" },
          [
            _c(
              "c-table",
              {
                ref: "gasTable",
                staticClass: "q-mt-md",
                attrs: {
                  title: "가스농도 측정",
                  columns: _vm.grid2.columns,
                  gridHeight: _vm.grid2.height,
                  data: _vm.workPermit.gases,
                  filtering: false,
                  columnSetting: false,
                  usePaging: false,
                  editable: _vm.gasEditable,
                  selection: "multiple",
                  rowKey: "sopGasCheckId",
                },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가",
                                icon: "add",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.addGas },
                            })
                          : _vm._e(),
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "제외",
                                icon: "remove",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.removeGas },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
          [
            _c(
              "c-card",
              {
                staticClass: "cardClassDetailForm no-margin",
                attrs: { title: "발급 정보" },
              },
              [
                _c("template", { slot: "card-detail" }, [
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("c-field", {
                        attrs: {
                          required: true,
                          disabled: !_vm.isWriting,
                          editable: _vm.editable,
                          data: _vm.workPermit,
                          deptValue: "issuedDeptCd",
                          type: "dept_user",
                          label: "발급",
                          beforeText: "",
                          name: "issuedUserId",
                        },
                        model: {
                          value: _vm.workPermit.issuedUserId,
                          callback: function ($$v) {
                            _vm.$set(_vm.workPermit, "issuedUserId", $$v)
                          },
                          expression: "workPermit.issuedUserId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("c-field", {
                        attrs: {
                          required: true,
                          disabled: !_vm.isWriting,
                          editable: _vm.editable,
                          data: _vm.workPermit,
                          deptValue: "approvalDeptCd",
                          type: "dept_user",
                          label: "승인",
                          beforeText: "",
                          name: "approvalUserId",
                        },
                        model: {
                          value: _vm.workPermit.approvalUserId,
                          callback: function ($$v) {
                            _vm.$set(_vm.workPermit, "approvalUserId", $$v)
                          },
                          expression: "workPermit.approvalUserId",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
          [
            _c(
              "c-card",
              {
                staticClass: "cardClassDetailForm no-margin",
                attrs: {
                  title: "안전조치확인 정보",
                  disabled: !_vm.safetyCheckConfirmEditable,
                },
              },
              [
                _c(
                  "template",
                  { slot: "card-disabled-area" },
                  [
                    _c(
                      "q-chip",
                      {
                        staticClass: "workpermit-disabled-comment",
                        attrs: {
                          square: "",
                          color: "deep-orange",
                          "text-color": "white",
                          icon: "warning_amber",
                        },
                      },
                      [_vm._v(" L&F 담당자 입력 후 이용바랍니다. ")]
                    ),
                  ],
                  1
                ),
                _c("template", { slot: "card-detail" }, [
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("c-field", {
                        attrs: {
                          required: true,
                          disabled:
                            !_vm.isWriting || !_vm.safetyCheckConfirmEditable,
                          editable: _vm.editable,
                          data: _vm.workPermit,
                          plantCd: _vm.firstManagerInfo.plantCd,
                          deptName: _vm.firstManagerInfo.deptName,
                          deptValue: "maintenanceDeptCheckDeptCd",
                          type: "dept_user",
                          userType: "lnf",
                          label: "공사담당자",
                          name: "maintenanceDeptCheckUserId",
                        },
                        model: {
                          value: _vm.workPermit.maintenanceDeptCheckUserId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.workPermit,
                              "maintenanceDeptCheckUserId",
                              $$v
                            )
                          },
                          expression: "workPermit.maintenanceDeptCheckUserId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("c-field", {
                        attrs: {
                          required: true,
                          disabled:
                            !_vm.isWriting || !_vm.safetyCheckConfirmEditable,
                          editable: _vm.editable,
                          data: _vm.workPermit,
                          plantCd: _vm.firstManagerInfo.plantCd,
                          deptName: _vm.firstManagerInfo.deptName,
                          deptValue: "maintenanceDeptEntryDeptCd",
                          type: "dept_user",
                          userType: "lnf",
                          label: "안전보건팀",
                          name: "maintenanceDeptEntryUserId",
                        },
                        model: {
                          value: _vm.workPermit.maintenanceDeptEntryUserId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.workPermit,
                              "maintenanceDeptEntryUserId",
                              $$v
                            )
                          },
                          expression: "workPermit.maintenanceDeptEntryUserId",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
          [
            _c(
              "c-card",
              {
                staticClass: "cardClassDetailForm no-margin",
                attrs: { title: "승인 정보" },
              },
              [
                _c("template", { slot: "card-detail" }, [
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("c-field", {
                        attrs: {
                          required: true,
                          disabled: !_vm.isWriting,
                          editable: _vm.editable,
                          data: _vm.workPermit,
                          deptValue: "headConstructionDeptCd",
                          type: "dept_user",
                          label: "공사 담당부서장",
                          beforeText: "",
                          name: "headConstructionDeptUserId",
                        },
                        model: {
                          value: _vm.workPermit.headConstructionDeptUserId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.workPermit,
                              "headConstructionDeptUserId",
                              $$v
                            )
                          },
                          expression: "workPermit.headConstructionDeptUserId",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }